import { useIsFocused } from "@react-navigation/native";
import { useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { AuthenticationModal } from "../../../features/Authentication/components/AuthenticationModal";
import {
  ActiveClubLanguageProvider,
  LocaleTransitionBoundary,
} from "../../../features/LanguagePreference";
import { RegisterAccountContainerQueryString } from "../../Register/components/RegisterAccountContainer";
import { RegisterAccountContainerQuery } from "../../Register/components/__generated__/RegisterAccountContainerQuery.graphql";

export const ResetPasswordContainer = ({
  queryRef,
  token,
  onComplete,
  handleBadToken,
}: {
  queryRef: PreloadedQuery<RegisterAccountContainerQuery>;
  token: string;
  onComplete: () => void;
  handleBadToken: () => void;
}) => {
  const data = usePreloadedQuery(RegisterAccountContainerQueryString, queryRef);
  const isFocused = useIsFocused();
  const email = data.setPasswordToken?.email || "";

  useEffect(() => {
    if (isFocused && !email) {
      handleBadToken();
    }
  }, [email, handleBadToken, isFocused]);

  if (!email) return null;

  return (
    <ActiveClubLanguageProvider
      active={isFocused}
      locale={data.setPasswordToken?.club.defaultLocale}
    >
      <LocaleTransitionBoundary>
        <AuthenticationModal
          isOpen={true}
          onComplete={onComplete}
          onClose={() => {}}
          clubSlug={data.setPasswordToken?.club.slug}
          hideCloseButton
          initialStep={{
            step: "ResetPassword",
            backStep: "Initial",
            verifiedEmail: email ?? "",
            token,
          }}
        />
      </LocaleTransitionBoundary>
    </ActiveClubLanguageProvider>
  );
};
